import {useEffect} from 'react';
import {useAuth} from '../auth/AuthProvider';
import supabase from '../supabase/supabase';
import {scheduleVisibleView, visitorId} from '../services/quoteViewTracking';

export function useQuoteViewTracking(shareToken, ready) {
  const {session, loading} = useAuth();
  useEffect(() => {
    if (!ready || !shareToken || loading || session) return undefined;
    return scheduleVisibleView(document, () => {
      // Tracking is deliberately independent of the quote loading/acceptance flow.
      const eventId = crypto.randomUUID();
      void supabase.functions.invoke('quote-viewed', {body:{
        share_token:shareToken, event_id:eventId, visitor_id:visitorId(),
      }}).catch(() => {});
    });
  }, [shareToken, ready, loading, session]);
}
